/**
 * @module ProductFeatures
 */

import Component from '../../base/Component';
import './styles.css';
import '../../../images/frontend/bg_1.jpg';
import '../../../images/frontend/bg_1.png';
import '../../../images/frontend/bg_2.jpg';
import '../../../images/frontend/bg_2.png';

/**
 * Название компонента.
 */
export default class ProductFeatures extends Component {
    static className = 'product-features';
}
